import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api, { formatGBP, formatDateUK } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import AuditTimeline from "@/components/AuditTimeline";
import PaymentActions from "@/components/PaymentActions";
import { KIND_LABEL, STATUS_LABEL } from "@/pages/PaymentsPage";

const Row = ({ k, v, id }) => (
  <div className="flex justify-between py-2 border-b border-navy/5 last:border-0 text-sm"><span className="text-navy/60">{k}</span><span className="text-navy font-medium" data-testid={id}>{v}</span></div>
);

export default function ViewPaymentPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    api.get(`/payments/${id}`).then((r) => setData(r.data)).catch(() => setData(false));
  }, [id, reload]);
  if (data === false) return <p className="text-navy/60" data-testid="payment-not-found">Payment not found.</p>;
  if (!data) return <p className="text-navy/60">Loading…</p>;
  return (
    <div className="space-y-5" data-testid="view-payment-page">
      <button type="button" onClick={() => navigate("/payments")} className="flex items-center gap-1 text-sm text-navy/60 min-h-[44px]" data-testid="view-payment-back-btn"><ArrowLeft className="w-4 h-4" /> Back</button>
      <h1 className="text-2xl font-bold text-navy">{KIND_LABEL[data.kind]}</h1>
      <Card className="border-navy/5 shadow-none"><CardContent className="p-4">
        <Row k="Status" v={STATUS_LABEL[data.status]} id="payment-detail-status" />
        <Row k="Amount" v={formatGBP(data.amount)} id="payment-detail-amount" />
        <Row k="Date" v={formatDateUK(data.movement_date)} id="payment-detail-date" />
        <Row k="Method" v={data.method.replace("_", " ")} id="payment-detail-method" />
        <Row k="Reference" v={data.reference || "—"} id="payment-detail-reference" />
        <Row k="Recorded by" v={data.submitted_by_name} id="payment-detail-by" />
        {data.origin === "purchase" && <Row k="Recorded with" v={`Invoice #${data.source_purchase_id} (Paid in Full)`} id="payment-detail-origin" />}
        {data.void_reason && <Row k={data.status === "reversed" ? "Reversal reason" : "Reason"} v={data.void_reason} id="payment-detail-reason" />}
        {data.allocations.map((a, i) => (
          <Row key={i} k={a.purchase_id ? `Invoice #${a.purchase_id}` : `Credit sale #${a.account_sale_id}`} v={formatGBP(a.amount)} id={`payment-detail-alloc-${i}`} />
        ))}
      </CardContent></Card>
      <PaymentActions data={data} onDone={() => setReload((n) => n + 1)} />
      <AuditTimeline history={data.history} kind="payment" />
    </div>
  );
}
